import { createContext, useContext } from 'react';
export const ViewportContext = /*#__PURE__*/createContext({});
export const useViewport = () => useContext(ViewportContext);